import moment from 'moment';
import config from 'config';
import {v4 as uuidv4} from 'uuid';
import FeatureToggleUtils from 'FeatureToggleUtils';

export const formatUtcTime = (date) => {
    const momentDate = !moment.isMoment(date) ? moment(date) : date;
    // moment is mutable, clone in order to reuse the original
    const utcMomentDate = !momentDate.isUTC() ? momentDate.clone().utc() : momentDate;
    return utcMomentDate.format('YYYYMMDDTHHmmssZ')
        .replace('+00:00', 'Z');
};

export const formatTime = (date) => {
    const momentDate = !moment.isMoment(date) ? moment(date) : date;
    return momentDate.format('YYYYMMDDTHHmmss');
};

const calendarTypes = {
    google: 'GOOGLE',
    outlook: 'ICALENDAR',
    yahoo: 'YAHOO',
    ical: 'ICALENDAR',
};

export const buildUrl = (event, type, magicLink, isLoggedIn, session) => {
    const isNewCalendarLinksEnabled = FeatureToggleUtils.isFeatureEnabled('new-calendar-links');

    let calendarUrl = '';
    let sessionUrl = '';
    const { websiteType = '', whitelabelUrl, id = '', eventUrls: { agendaUrl } = {}, startTime = moment.now(), endTime = moment.now(),
        location = '', title = '', description = ''
    } = event;
    const isSessionView = document.URL.includes('/session/');

    if (isNewCalendarLinksEnabled) {
        const eventsDomain = websiteType === 'whitelabel' ? `https://${whitelabelUrl}` : config.eventsUrl;
        calendarUrl = `${eventsDomain}/calendars/${calendarTypes[type] || calendarTypes.ical}/accounts/${event.accountId}/events/${event.eventId}`;
        if (session) {
            calendarUrl += '/sessions/' + session.id;
        }
        return calendarUrl;
    }

    if (websiteType === 'independent'){
        sessionUrl = `${agendaUrl}?agendaPath=session/${id}`;
    } else {
        sessionUrl = !isSessionView ? document.URL + '/session/' + event.id : document.URL;
    }
    if (magicLink) {
        sessionUrl = isLoggedIn ?
            `${magicLink}&redirectUrl=${sessionUrl}?login=ML` :
            `${sessionUrl}`;
    }

    switch (type) {
    case 'google':
        calendarUrl = 'https://calendar.google.com/calendar/render';
        calendarUrl += '?action=TEMPLATE';
        calendarUrl += '&dates=' + formatUtcTime(startTime);
        calendarUrl += '/' + formatUtcTime(endTime);
        calendarUrl += '&location=' + encodeURIComponent(location);
        calendarUrl += '&text=' + encodeURIComponent(title);
        calendarUrl += '&details=' + encodeURIComponent(description + '\n\n' + sessionUrl);
        break;

    // yahoo doesn't work well with utc, so instead we will use local time zone
    case 'yahoo':
        calendarUrl = 'https://calendar.yahoo.com/?v=60&view=d&type=20';
        calendarUrl += '&title=' + encodeURIComponent(title);
        calendarUrl += '&st=' + formatTime(startTime);
        calendarUrl += '&et=' + formatTime(endTime);
        calendarUrl += '&desc=' + encodeURIComponent(description + '\n\n' + sessionUrl);
        calendarUrl += '&in_loc=' + encodeURIComponent(location);
        break;

    default:
        calendarUrl = [
            'BEGIN:VCALENDAR',
            'PRODID:-//Bizzabo//EN',
            'VERSION:2.0',
            'BEGIN:VEVENT',
            'UID:' + uuidv4(),
            'DTSTAMP:' + formatUtcTime(moment.now()),
            'DTSTART:' + formatUtcTime(startTime),
            'DTEND:' + formatUtcTime(endTime),
            'SUMMARY:' + foldText(title),
            'DESCRIPTION:' + foldText(description.replace(/(\r\n|\n|\r)/gm, '\\n') + '\\n\\n' +sessionUrl),
            'LOCATION:' + location,
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\n');
        calendarUrl = `${config.eventsUrl}/download/ical?data=${encodeURIComponent(calendarUrl)}`;
        break;
    }

    return calendarUrl;
};

function foldText(input, maxLineLength = 60) {
    let foldedText = '';
    let currentIndex = 0;

    while (currentIndex < input.length) {
        let remainingCharacters = maxLineLength;

        // Append up to maxLineLength characters or until end of string
        while (currentIndex < input.length && remainingCharacters > 0) {
            const currentChar = input[currentIndex];
            foldedText += currentChar;
            currentIndex++;
            remainingCharacters--;

            if (currentChar === '\n') {
                // Reset the remaining characters count for a new line
                remainingCharacters = maxLineLength;
            }
        }

        // Add a CRLF followed by a single linear white-space character (SPACE or HTAB)
        if (currentIndex < input.length) {
            foldedText += '\r\n ';
        }
    }

    return foldedText;
}

